var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(_vm.get_interview_loading)?[_c('InterviewLoading')]:[_c('candidate-interview-wrapper')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }